import { get, postJson, post } from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let sfPlanApi = {}

sfPlanApi.insert = function (params) {
    return postJson('/sfplan/insert', params)
}

sfPlanApi.insertBatch = function (params) {
    return postJson('/sfplan/insertBatch', params)
}

sfPlanApi.update = function (params) {
    return postJson('/sfplan/update', params)
}

sfPlanApi.select = function (params) {
    return postJson('/sfplan/select', params)
}

sfPlanApi.delete = function (params) {
    return postJson('/sfplan/delete', params)
}

sfPlanApi.invalidate = function (params) {
    return postJson('/sfplan/invalidate', params)
}

sfPlanApi.check = function (params) {
    return postJson('/sfplan/check', params)
}

sfPlanApi.terminate = function (params) {
    return postJson('/sfplan/terminate', params)
}

sfPlanApi.pass = function (params) {
    return postJson('/sfplan/pass', params)
}

sfPlanApi.reject = function (params) {
    return postJson('/sfplan/reject', params)
}